import React, { Component } from 'react'
import FormViewer from '../../FormViewer'
import ButtonAnimated from '../../buttons/ButtonAnimated'
import { getObject, translate } from '../../../utils/useful'
import HttpServices from '../../../utils/Http.services'
import store from '../../../stores/storeConfig'
import { addNotif } from '../../../stores/actionsList'

export default class EasyPost extends Component {
    state = {
        fields: [
            { key: 'accessKey', type: 'TextInput', col: '6', information: { label: '{{lang}}Easy Posst Api Key', placeholder: '', required: true } },
        ]
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }


    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }

    submitForm = () => {
        let data = this.form.getForm()
        if (data) {

            let api = getObject(data, 'accessKey')
            HttpServices.request('checkEasyPostApiKey', { accessKey: api }, (fetchResult, fetchError) => {
                if (fetchError) {
                    store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message }))
                    return
                }
                let thirdparty = this.form.getForm() ?? {}
                this.props.changeInputValue(thirdparty)
                store.dispatch(addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' }))

            })
        }
    }

    render() {
        return (
            <div className="w-100 h-100  pt-2 pb-4"  >
                <div className='flexc px-3 pb-3' style={{ borderBottom: '1px solid #eee' }}>
                    <div className='flexcc'>
                        <img src='/assets/easypost.svg' height={50} />
                    </div>
                    <div className='mld-4'>
                        <p className='text-bold text-normal'>{translate("Connect to your EasyPost account")}</p>
                        <a className='text-link text-small' href='https://www.easypost.com/' target='_blank' rel="noreferrer">{translate("Don't have an account? Click here")}</a>
                    </div>
                </div>

                <div className='mt-3 px-3'>
                    <div className='text-small br-8 p-3' style={{ backgroundColor: '#007aff10' }}>
                        <p className='text-bold mb-1'>Note</p>
                        <p>- Yonnect needs your Production API key</p>
                        <p>- Login to your EasyPost account.</p>
                        <p>- Navigate to your Account Settings &gt; API Keys.</p>
                        <p>- Add a new Production API Key or just copy an existing one.</p>
                        <a className='text-link text-small' href='https://www.easypost.com/account/settings?tab=api-keys' target='_blank' rel="noreferrer">{translate("Find your API key here")}</a>
                    </div>
                </div>


                <div className='mt-4'>
                    <FormViewer ref={el => this.form = el} headers={this.state.fields} formClass="bordered-form" inputClass={'bordered-input'} />
                </div>


                <div className='mt-0 px-3'>
                    <ButtonAnimated
                        icon={'/assets/icons/angle-right-white2.svg'}
                        bg={'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))'}
                        textColor={'#fff'}
                        title={'{{lang}}Add EasyPost'}
                        invert={false}
                        onClick={() => this.submitForm()}
                    />
                </div>
            </div>
        )
    }
}
